<div class="container mx-auto px-4 py-8">
  <div class="bg-white rounded-lg shadow-lg p-6">
    <h2 class="text-2xl font-bold mb-6 mt-24">Historial de Acciones</h2>

    <!-- Filtros de búsqueda -->
    <div class="mb-6 grid grid-cols-1 md:grid-cols-4 gap-4">
      <div class="form-control">
        <input type="text" [(ngModel)]="searchTerm" (keyup)="onSearch()" placeholder="Buscar en el historial..."
          class="input input-bordered w-full">
      </div>
      <div class="form-control">
        <select [(ngModel)]="selectedActionType" (change)="onSearch()" class="select select-bordered w-full">
          <option value="">Todos los tipos de acción</option>
          <option *ngFor="let type of actionTypes" [value]="type">{{ type }}</option>
        </select>
      </div>
      <div class="form-control">
        <select [(ngModel)]="selectedEntityType" (change)="onSearch()" class="select select-bordered w-full">
          <option value="">Todas las entidades</option>
          <option value="Order">Órdenes</option>
          <option value="SparePart">Repuestos</option>
          <option value="Workshop">Talleres</option>
          <option value="PackageList">Lista Paquetes</option>
          <option value="PackageListItem">Lista Items Paquetes</option>
          <option value="ExportedFolder">Carpeta Exportadas</option>
        </select>
      </div>
      <div class="form-control">
        <input type="date" [(ngModel)]="selectedDate" (change)="onSearch()" class="input input-bordered w-full">
      </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="flex justify-center items-center py-12">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
    </div>

    <!-- Tabla de resultados -->
    <div *ngIf="!isLoading" class="overflow-x-auto">
      <table class="table w-full">
        <thead>
          <tr>
            <th>Fecha</th>
            <th>Usuario</th>
            <th>Tipo de Acción</th>
            <th>Descripción</th>
            <th>Entidad</th>
            <th>ID Entidad</th>
            <th>Detalles</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let action of actions" class="hover:bg-gray-50">
            <td>{{ action.createdAt | date:'dd/MM/yyyy HH:mm' }}</td>
            <td>{{ action.user?.userName || 'Usuario desconocido' }}</td>
            <td>
              <span class="badge" [ngClass]="getActionTypeClass(action.actionType)">
                {{ action.actionType }}
              </span>
            </td>
            <td>{{ action.description }}</td>
            <td>{{ entityType(action.entityType) }}</td>
            <td>{{ action.entityId || 'N/A' }}</td>
            <td>
              <button *ngIf="action.additionalData" class="btn btn-xs btn-info" (click)="showDetails(action)">
                Ver detalles
              </button>
            </td>
          </tr>
          <tr *ngIf="actions.length === 0">
            <td colspan="7" class="text-center py-4">No se encontraron registros</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Paginación -->
    <div class="flex justify-between items-center mt-4">
      <div class="text-sm text-gray-600">
        Mostrando {{ (currentPage - 1) * pageSize + 1 }} - {{ currentPage * pageSize }} de {{ totalItems }}
        registros
      </div>
      <div class="btn-group">
        <button class="btn btn-sm" [disabled]="currentPage === 1" (click)="onPageChange(currentPage - 1)">
          «
        </button>
        <button class="btn btn-sm" [disabled]="currentPage === totalPages" (click)="onPageChange(currentPage + 1)">
          »
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal para mostrar detalles -->
<div *ngIf="selectedAction" class="modal modal-open">
  <div class="modal-box">
    <h3 class="font-bold text-lg mb-4">Detalles de la Acción</h3>
    <div class="space-y-2">
      <p><strong>Fecha:</strong> {{ selectedAction.createdAt | date:'dd/MM/yyyy HH:mm:ss' }}</p>
      <p><strong>Usuario:</strong> {{ selectedAction.user?.userName || 'Usuario desconocido' }}</p>
      <p><strong>Tipo de Acción:</strong>
        <span class="badge" [ngClass]="getActionTypeClass(selectedAction.actionType)">
          {{ selectedAction.actionType }}
        </span>
      </p>
      <p><strong>Descripción:</strong> {{ selectedAction.description }}</p>
      <p><strong>Entidad:</strong> {{ entityType(selectedAction.entityType) }}</p>
      <p><strong>ID Entidad:</strong> {{ selectedAction.entityId || 'N/A' }}</p>
      <p>
        <strong>Orden:</strong>
        <span *ngIf="loadingDetailsInfo"> Cargando...</span>
        <span *ngIf="!loadingDetailsInfo"> {{ detailsOrderNumber || 'N/A' }}</span>
      </p>
      <p>
        <strong>Sinistro:</strong>
        <span *ngIf="loadingDetailsInfo"> Cargando...</span>
        <span *ngIf="!loadingDetailsInfo"> {{ detailsSiniestro || 'N/A' }}</span>
      </p>

      <!-- Cambios realizados (UPDATE: anterior → nuevo) -->
      <div *ngIf="parsedChanges.length > 0" class="mt-4">
        <h4 class="font-semibold mb-3 text-base flex items-center">
          <i class="fas fa-edit text-blue-500 mr-2"></i>Cambios realizados
        </h4>
        <div class="space-y-2 max-h-72 overflow-y-auto">
          <div *ngFor="let change of parsedChanges"
            class="flex flex-wrap items-baseline gap-2 py-2 px-3 bg-gray-50 rounded-lg border border-gray-200">
            <span class="font-medium text-gray-700 shrink-0">{{ change.fieldLabel }}:</span>
            <span class="text-gray-500 text-sm">{{ change.from }}</span>
            <span class="text-gray-400 shrink-0"><i class="fas fa-arrow-right text-xs mx-1"></i></span>
            <span class="text-green-700 font-medium">{{ change.to }}</span>
          </div>
        </div>
      </div>
      <!-- Datos creados (CREATE: mismo estilo de panel, solo campo + valor) -->
      <div *ngIf="parsedCreateData.length > 0" class="mt-4">
        <h4 class="font-semibold mb-3 text-base flex items-center">
          <i class="fas fa-plus-circle text-green-600 mr-2"></i>Datos creados
        </h4>
        <div class="space-y-2 max-h-72 overflow-y-auto">
          <div *ngFor="let item of parsedCreateData"
            class="flex flex-wrap items-baseline gap-2 py-2 px-3 bg-gray-50 rounded-lg border border-gray-200">
            <span class="font-medium text-gray-700 shrink-0">{{ item.fieldLabel }}:</span>
            <span class="text-green-700 font-medium">{{ item.value }}</span>
          </div>
        </div>
      </div>
      <!-- Datos adicionales en bruto (solo si no hay cambios ni datos de creación parseados) -->
      <div *ngIf="selectedAction.additionalData && parsedChanges.length === 0 && parsedCreateData.length === 0" class="mt-4">
        <h4 class="font-semibold mb-2">Datos adicionales</h4>
        <pre class="bg-gray-100 p-3 rounded text-sm overflow-auto max-h-60 whitespace-pre-wrap break-words">{{ formattedAdditionalData }}</pre>
      </div>
    </div>

    <div class="modal-action">
      <button class="btn" (click)="closeDetails()">Cerrar</button>
    </div>
  </div>
</div>